import { Box } from "@mui/joy";
import { toDateInputValue } from "../../../excursions/shared/utils/excursionUtils";
import DarkDatePicker from "components/common/DarkDatePicker";
import DarkTimePicker from "components/common/DarkTimePicker";

export type ExcursionModalFormFieldsProps = {
  date: string;
  onDateChange: (value: string) => void;
  startTime: string;
  onStartTimeChange: (value: string) => void;
  endTime: string;
  onEndTimeChange: (value: string) => void;
  canEdit: boolean;
};

export default function ExcursionModalFormFields({
  date,
  onDateChange,
  startTime,
  onStartTimeChange,
  endTime,
  onEndTimeChange,
  canEdit,
}: ExcursionModalFormFieldsProps) {
  return (
    <Box sx={{ display: "flex", gap: { xs: 1, sm: 2 }, alignItems: "flex-end" }}>
      <DarkDatePicker
        label="Date"
        labelSize="compact"
        formControlProps={{ sx: { flex: { xs: "1 1 0", sm: "1 1 140px" }, minWidth: 0 } }}
        value={toDateInputValue(date)}
        onChange={onDateChange}
        disabled={!canEdit}
      />
      <DarkTimePicker
        label="Début"
        labelSize="compact"
        mode="start"
        formControlProps={{ sx: { flex: { xs: "1 1 0", sm: "1 1 100px" }, minWidth: 0 } }}
        value={startTime}
        onChange={onStartTimeChange}
        disabled={!canEdit}
      />
      <DarkTimePicker
        label="Fin"
        labelSize="compact"
        mode="end"
        startTime={startTime}
        formControlProps={{ sx: { flex: { xs: "1 1 0", sm: "1 1 100px" }, minWidth: 0 } }}
        value={endTime}
        onChange={onEndTimeChange}
        disabled={!canEdit}
      />
    </Box>
  );
}
